import { useState, useContext } from "react";
import Button from "../../../../common/Button/Button";
import { ApiContext } from "../../../../context/MyContext";
import { deleteEmployee } from "../../../../service/employeeService";
import { getApiErrorMessage, resolveEmployeeId } from "../employeeListUtils";

const DeleteConfirmationModal = ({
  employee,
  onClose,
  onDeleteSuccess,
  onToast,
}) => {
  const { remove } = useContext(ApiContext);
  const [loading, setLoading] = useState(false);
  const employeeId = resolveEmployeeId(employee);

  const handleDelete = async () => {
    if (!employeeId) {
      onToast(
        "This person has no employee record yet, so they can’t be deleted.",
        "error"
      );
      return;
    }

    setLoading(true);
    try {
      await deleteEmployee(remove, employeeId);
      onToast("Employee Deleted!", "success");
      onDeleteSuccess();
    } catch (error) {
      console.error("Delete failed:", error.message);
      onToast(getApiErrorMessage(error, "Failed to delete employee"), "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-orange-primary bg-opacity-20 flex justify-center items-center z-50"
      onClick={onClose}
    >
      <div
        className="bg-white p-6 rounded-lg shadow-lg w-[400px] text-center"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-bold mb-4 text-gray-800">Confirm Delete</h2>
        <p className="text-gray-600 mb-6">
          Are you sure you want to delete <strong>{employee.name}</strong>? This
          action cannot be undone.
        </p>
        <div className="flex justify-end gap-2">
          <Button
            text="Cancel"
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded-md"
            onClick={onClose}
            disabled={loading}
          />
          <Button
            text={loading ? "Deleting..." : "Delete"}
            className="bg-error-red text-white px-4 py-2 rounded-md disabled:opacity-50"
            onClick={handleDelete}
            disabled={loading || !employeeId}
          />
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;
